import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthStore } from '@webapp/shared';

import { environment } from '../../environments/environment';

export const AuthHttpInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const requestUrl = req.url;
  const apiUrl = environment.apiUrl;

  if (!requestUrl.startsWith(apiUrl)) {
    return next(req);
  }

  const authStore = inject(AuthStore);
  const accessToken = authStore.jwt();

  const requestClone = accessToken
    ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${accessToken}`) })
    : req;

  return next(requestClone);
};
